import React from 'react'

/**
 * Pixel-art sprites for the boss invader UI, drawn as SVG rect grids
 * (crispEdges) to match the board's pixel planets. The mothership is tinted
 * with the race color; shading comes from black/white overlay rects so any
 * race color works on either theme. The missile inherits `currentColor`, so
 * it stays readable wherever the surrounding text is.
 */

const LIGHT = '#ffd76a'

/** The race's mothership — a saucer in the boss color. */
export const BossSprite = ({ color, width = 45, className }: { color: string, width?: number, className?: string }) => (
  <svg
    className={className}
    width={width}
    height={width * (11 / 15)}
    viewBox="0 0 15 11"
    shapeRendering="crispEdges"
    role="img"
    aria-label="Boss mothership"
  >
    {/* dome */}
    <rect x="6" y="0" width="3" height="1" fill={color} />
    <rect x="5" y="1" width="5" height="2" fill={color} />
    <rect x="6" y="0" width="1" height="2" fill="#ffffff" opacity="0.35" />
    {/* cockpit */}
    <rect x="7" y="1" width="1" height="2" fill={LIGHT} />
    {/* hull */}
    <rect x="3" y="3" width="9" height="1" fill={color} />
    <rect x="1" y="4" width="13" height="2" fill={color} />
    <rect x="2" y="6" width="11" height="1" fill={color} />
    <rect x="2" y="6" width="11" height="1" fill="#000000" opacity="0.25" />
    {/* running lights */}
    <rect x="3" y="4" width="1" height="1" fill={LIGHT} />
    <rect x="6" y="4" width="1" height="1" fill="#ffffff" />
    <rect x="9" y="4" width="1" height="1" fill={LIGHT} />
    <rect x="12" y="4" width="1" height="1" fill={LIGHT} />
    {/* tractor beam */}
    <rect x="5" y="7" width="5" height="1" fill={color} opacity="0.45" />
    <rect x="6" y="8" width="3" height="1" fill={color} opacity="0.3" />
    <rect x="7" y="9" width="1" height="2" fill={color} opacity="0.2" />
  </svg>
)

/** A missile in flight, pointing right; body/fins take the surrounding text color. */
export const MissileSprite = ({ width = 24, className }: { width?: number, className?: string }) => (
  <svg
    className={className}
    width={width}
    height={width * (3 / 8)}
    viewBox="0 0 8 3"
    shapeRendering="crispEdges"
    role="img"
    aria-label="Missile"
  >
    {/* exhaust flame */}
    <rect x="0" y="1" width="1" height="1" fill="#ff9e3d" />
    {/* fins */}
    <rect x="1" y="0" width="1" height="1" fill="currentColor" opacity="0.7" />
    <rect x="1" y="2" width="1" height="1" fill="currentColor" opacity="0.7" />
    {/* body */}
    <rect x="1" y="1" width="5" height="1" fill="currentColor" />
    {/* warhead */}
    <rect x="6" y="1" width="1" height="1" fill="currentColor" opacity="0.6" />
    <rect x="7" y="1" width="1" height="1" fill="#ff5a5a" />
  </svg>
)
